module.exports = __webpack_public_path__ + "static/img/product_lotus2_small.50ac7f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product_lotus2_small.png
// module id = pP4I
// module chunks = 1